if (document.querySelector('.video-section')) {
    document.addEventListener('DOMContentLoaded', function () {
        const videoSections = document.querySelectorAll('.video-block');
    
        videoSections.forEach(function(videoSection) {
            const videoContainer = videoSection.querySelector('.video-container');
            const videoThumbnail = videoSection.querySelector('.video-thumbnail');
            const video = videoSection.querySelector('video');
    
            videoSection.addEventListener('click', function () {
                if (videoContainer.style.display === 'none' || videoContainer.style.display === '') {
                    videoThumbnail.style.display = 'none';
                    videoContainer.style.display = 'block';
                    video.play();
                    video.muted = false;
                } else {
                    video.pause();
                    video.muted = true;
                    videoContainer.style.display = 'none';
                    videoThumbnail.style.display = 'block';
                }
            });
        });
    });   
}


const header = document.querySelector('.section-header');
const main = document.getElementById('MainContent');

function toggleHeaderScrolledClass() {
    if (header.classList.contains('scrolled-past-header')) {
        main.classList.add('header-scrolled');
    } else {
        main.classList.remove('header-scrolled');
    }
}

const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        if (mutation.attributeName === 'class') {
            toggleHeaderScrolledClass();
        }
    });
});

observer.observe(header, { attributes: true });

toggleHeaderScrolledClass();

document.addEventListener('DOMContentLoaded', () => {
    if (window.innerHeight > 0) {
        window.scrollBy(0, 1);
    }
});